interface Location {
    href: string;
    protocol: string;
    host: string;
    hostname: string;
    port: number;
    pathname: string;
    search: string;
    hash: string;
}

export const getLocation = (href: string): Location => {
    let match = href.match(/^(https?:)\/\/(([^:\/?#]*)(?::([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: Number(match[4]),
        pathname: match[5],
        search: match[6],
        hash: match[7]
    } as Location;
};

export const isLocationPath = (href: string, path: string): boolean => {
    let match = href.match(/^(https?:)\/\/(([^:\/?#]*)(?::([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);

    if (!match) {
        return false
    }

    let matchParts = {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };

    return matchParts.pathname === path;
};
